module.exports = __webpack_public_path__ + "img/arrow-down-icon.281ae267.svg";